import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title } from 'react-admin';
import { translate } from 'react-admin';
const dashboard = ({translate}) => (
    <Card>
        <Title title="ra.page.dashboard" />
        <CardContent>{translate('dashboard.message')}</CardContent>
    </Card>
);
export default translate(dashboard);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard.js